import init from '../../helpers/init';

const {$} = init;

$(() => {
  $(document).on('change', '.js-county-select', (e) => {
    if ($(e.currentTarget).val() !== '7448') {
      $('.js-region-select').val(0);
      $('.js-region-select').select2().val(0);
      $('.js-region-select').parent().parent().css('display', 'none');
    } else {
      $('.js-region-select').parent().parent().css('display', 'block');
      $('.js-region-select').select2({theme: 'classic'})
    }
  });
});
